// extracted by mini-css-extract-plugin
module.exports = {"user":"MessengerSearchItemChatMessage_user__lxO-X"};